var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBUploadCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-upload-cloud",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M11.293,11.293c0.19,-0.19 0.444,-0.293 0.707,-0.293c0.263,0 0.517,0.103 0.707,0.293l4,4c0.39,0.39 0.39,1.024 0,1.414c-0.39,0.39 -1.024,0.39 -1.414,0l-2.293,-2.293l0,6.586c-0,0.552 -0.448,1 -1,1c-0.552,-0 -1,-0.448 -1,-1l0,-6.586l-2.293,2.293c-0.39,0.39 -1.024,0.39 -1.414,0c-0.39,-0.39 -0.39,-1.024 -0,-1.414l4,-4Zm-6.737,4.118c0.459,0.307 0.582,0.929 0.275,1.387c-0.307,0.459 -0.929,0.582 -1.387,0.275c-1.474,-0.986 -2.444,-2.666 -2.444,-4.573c-0,-2.607 1.815,-4.791 4.249,-5.356c0.814,-2.965 3.528,-5.144 6.751,-5.144c3.223,0 5.937,2.179 6.75,5.143c2.435,0.566 4.25,2.75 4.25,5.357c0,1.907 -0.97,3.587 -2.444,4.573c-0.458,0.307 -1.08,0.184 -1.387,-0.275c-0.307,-0.458 -0.184,-1.08 0.275,-1.387c0.938,-0.628 1.556,-1.697 1.556,-2.911c0,-1.822 -1.393,-3.32 -3.172,-3.485c-0.453,-0.042 -0.821,-0.384 -0.894,-0.833c-0.39,-2.373 -2.451,-4.182 -4.934,-4.182c-2.483,-0 -4.543,1.809 -4.934,4.182c-0.073,0.449 -0.441,0.791 -0.894,0.833c-1.779,0.165 -3.172,1.663 -3.172,3.485c0,1.214 0.618,2.283 1.556,2.911Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBUploadCloud);
export default __webpack_public_path__ + "static/media/iconB-upload-cloud.c187566aa734844c8745d77c14d9ff11.svg";
export { ForwardRef as ReactComponent };